var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserguidesDesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.6 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-userguides-designer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.38,20.11a.53.53,0,0,0,.6.41l1-.13a.51.51,0,0,1,.51.25,3.19,3.19,0,0,0,.41.51.57.57,0,0,1,.13.54l-.35.95a.54.54,0,0,0,.28.66l.89.44a.55.55,0,0,0,.7-.19l.51-.82a.49.49,0,0,1,.51-.25c.09,0,.19,0,.32,0a1.08,1.08,0,0,0,.32,0,.47.47,0,0,1,.51.25l.51.82a.55.55,0,0,0,.7.19l.89-.41a.54.54,0,0,0,.28-.66l-.38-1a.57.57,0,0,1,.13-.54,3.19,3.19,0,0,0,.41-.51.57.57,0,0,1,.54-.22l.95.13a.56.56,0,0,0,.6-.41l.22-.95a.56.56,0,0,0-.35-.63l-.92-.32a.52.52,0,0,1-.35-.44,3.73,3.73,0,0,0-.13-.63.57.57,0,0,1,.13-.54l.7-.7a.54.54,0,0,0,0-.73l-.6-.76a.54.54,0,0,0-.7-.13l-.82.54a.55.55,0,0,1-.54,0l-.6-.28a.56.56,0,0,1-.35-.44l-.09-1a.52.52,0,0,0-.54-.47h-1a.55.55,0,0,0-.54.47l-.09,1a.56.56,0,0,1-.35.44,2.1,2.1,0,0,0-.6.28.48.48,0,0,1-.54,0l-.82-.54a.51.51,0,0,0-.7.13l-.6.76a.57.57,0,0,0,0,.73l.7.7a.55.55,0,0,1,.13.54,3.73,3.73,0,0,0-.13.63.56.56,0,0,1-.35.44l-.92.32a.54.54,0,0,0-.35.63Zm5.44-4.24a2.34,2.34,0,1,1-2.34,2.34A2.33,2.33,0,0,1,13.81,15.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.81,
    cy: 18.21,
    r: 1.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.58,8.31a12.16,12.16,0,0,0-4,5.25.91.91,0,0,0,.54,1.2,1.34,1.34,0,0,0,.35.06.88.88,0,0,0,.85-.6A10.17,10.17,0,0,1,7.68,9.8.93.93,0,1,0,6.58,8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.18,27.19a10.24,10.24,0,0,1-4.36,1,9.89,9.89,0,0,1-4.36-1,.93.93,0,1,0-.79,1.68,12.23,12.23,0,0,0,10.31,0,.91.91,0,0,0,.44-1.23A1,1,0,0,0,18.18,27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.33,14.23a.94.94,0,0,0,.85.6,1.34,1.34,0,0,0,.35-.06.93.93,0,0,0,.54-1.2,12.16,12.16,0,0,0-4-5.25A.93.93,0,0,0,19.95,9.8,10.35,10.35,0,0,1,23.33,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.83,9.29A4.92,4.92,0,0,0,15.93,5a.2.2,0,0,0-.19,0,3.35,3.35,0,0,1-1.93.63A3.14,3.14,0,0,1,11.89,5c-.06,0-.13-.06-.19,0A4.92,4.92,0,0,0,9.8,9.29C9.8,10.56,17.83,10.56,17.83,9.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.81,
    cy: 2.4,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.13,21.18a.2.2,0,0,0-.19,0A3.35,3.35,0,0,1,4,21.81a3.14,3.14,0,0,1-1.93-.63c-.06,0-.13-.06-.19,0A4.92,4.92,0,0,0,0,25.45c0,1.26,8,1.26,8,0A4.77,4.77,0,0,0,6.13,21.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.01,
    cy: 18.56,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.7,21.18a.2.2,0,0,0-.19,0,3.35,3.35,0,0,1-1.93.63,3.14,3.14,0,0,1-1.93-.63c-.06,0-.13-.06-.19,0a4.92,4.92,0,0,0-1.9,4.27c0,1.26,8,1.26,8,0A4.77,4.77,0,0,0,25.7,21.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.61,
    cy: 18.56,
    r: 2.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserguidesDesigner);
export default __webpack_public_path__ + "static/media/icon-userguides-designer.a68eecfcc17b732bc15519a800d20840.svg";
export { ForwardRef as ReactComponent };